import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { traverse } from '@jd/jmtd-tools/es/tree';
import { getObjectValue } from './util';
export function GetItems(ctor, reducer) {
  return function (list, tree) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$valueName = _ref.valueName,
        valueName = _ref$valueName === void 0 ? 'value' : _ref$valueName;

    var result = ctor();
    var set = new Set(list);
    traverse(tree, function (item, cxt) {
      if (set.has(getObjectValue(item, valueName))) {
        result = reducer(result, _objectSpread(_objectSpread({}, item), cxt), {
          valueName: valueName
        });
      }
    });
    return result;
  };
}
export var getTreeItemList = GetItems(function () {
  return [];
}, function (list, item) {
  list.push(item);
  return list;
});
export var getTreeItemTable = GetItems(function () {
  return {};
}, function (table, item, _ref2) {
  var valueName = _ref2.valueName;
  table[getObjectValue(item, valueName)] = item;
  return table;
});